class LoginHandler {
    loginValue = null;
    blockHistory = [];

    customerId = null;
    confirmedPhone = false;
    email = null;
    phone = null;
    type = null;
    customerNew = false;
    secondLogin = null;
    storefrontLoginUrl = null;

    constructor() {
        this.storefrontLoginUrl = document.querySelector(".custom_login_last")?.dataset.storefrontLoginUrl || null;

        if (this.#redirectLoggedInCustomer()) {
            return;
        }

        if(this.#isCustomerSecondary()) {
            this.#changeLabelText("emailPhoneBlock", "Telefonnummer");
            this.#addPlaceholder("emailPhoneInput", "+41")
        }

        this.#setupEventListeners("emailPhoneInput", "emailPhoneButton");
        this.#setupEventListeners("verificationInput", "verificationButton");
        this.#setupEventListeners("emailOrPhoneInput", "emailOrPhoneButton");
        this.#setupEventListeners("nameInput", "nameButton");
        this.#setupEventListeners("finalPasswordInput", "finalPasswordButton");


        this.#setupPasswordEventListeners("passwordInput", "passwordConfirmInput", "passwordButton");
    }

    #fillObjects(customer) {
        const { customerId, confirmedPhone, email, phone, type, new: customerNew } = customer;
        Object.assign(this, { customerId, confirmedPhone, email, phone, type, customerNew });
    }

    toggleInfoPopup() {
        var popup = document.getElementById("infoPopup");
        popup.style.display = (popup.style.display === "block") ? "none" : "block";
    }

    showInfoPopup() {
        var popup = document.getElementById("infoPopup");
        popup.style.display = "block";
    }

    hideInfoPopup() {
        var popup = document.getElementById("infoPopup");
        popup.style.display = "none";
    }


    /********************* Main Blocks Functionality Handler *********************/
    /**
     * First login block sending.
     *
     * First block on login/registration area that customer sees.
     *
     * @returns {Promise<void>}
     */
    async login() {
        this.loginValue = document.getElementById("emailPhoneInput").value;

        if(this.#isCustomerSecondary() && !this.#isValidPhone(this.loginValue)) {
            this.#showError("emailPhoneBlock", "Telefonnummer ist nicht korrekt");
            return;
        }

        this.#showLoader("emailPhoneBlock");
        const customer = await this.#getCustomer(this.loginValue);

        if (!customer.success) {
            this.#hideLoader("emailPhoneBlock");
            this.#showError("emailPhoneBlock", customer.message);
            return;
        }

        this.#showLoader("emailPhoneBlock");
        this.hideError("emailPhoneBlock");
        this.#fillObjects(customer);

        this.#addBlockToHistory("emailPhoneBlock");

        if (this.type !== "phone" || this.confirmedPhone) {
            this.#hideLoader("emailPhoneBlock");
            this.#nextStep();
        } else {
            await this.sendVerification(this.loginValue);
        }
    }

    /**
     * Verifications code sending
     *
     * Section where customer enters received verification code and sends it for verification.
     *
     * @returns {Promise<void>}
     */
    async verifyCode() {
        this.#showLoader("verificationBlock");
        const code = document.getElementById("verificationInput").value;
        const response = await this.#checkVerificationCode(code);

        this.#hideLoader("verificationBlock");
        if (!response.success) {
            this.#showError("verificationBlock", response.message);
            return;
        }

        this.hideError("verificationBlock");
        this.#nextStep();
    }

    /**
     * Email or phone block.
     *
     * The block where customer enters his email or phone if he's a new one and doesn't have second login.
     */
    submitEmailOrPhone() {
        const emailPhoneValue = document.getElementById("emailOrPhoneInput").value;

        if(!this.#isValidEmail(emailPhoneValue)) {
            if(!this.#isValidPhone(emailPhoneValue)) {
                const errorType = this.#getSecondLoginText();
                this.#showError("emailOrPhoneBlock", `Die ${errorType.head} ist nicht korrekt`);
                return;
            }
        }

        this.secondLogin = emailPhoneValue;
        this.hideError("emailOrPhoneBlock");

        if (!this.customerNew) {
            this.#showFinalPasswordBlock();
            return;
        }

        this.#addBlockToHistory("emailOrPhoneBlock");
        this.#showNameBlock();
    }

    /**
     * Name block
     *
     * Section where customer enters his name
     */
    submitName() {
        const nameValue = document.getElementById("nameInput").value;

        if(!nameValue) {
            this.#showError("nameBlock", "Bitte nutzen Sie das Feld nicht leer");
            return;
        }

        if(this.#hasSpecialSymbols(nameValue)) {
            this.#showError("nameBlock", "Bitte nutzen Sie keine Sonderzeichen");
            return;
        }

        this.hideError("nameBlock");
        this.#addBlockToHistory("nameBlock");

        if (!this.customerNew) {
            this.#showFinalPasswordBlock();
            return;
        }

        this.#showPasswordBlock();
    }

    /**
     * Registration password form
     *
     * Section where we collect entered data and register the client according to it
     *
     * @returns {Promise<void>}
     */
    async submitForm() {
        this.#showLoader("passwordBlock");
        const formData = this.#getFormData();
        const formBlock = document.getElementById('passwordBlock');
        const response = await this.#apiRequest('POST', 'https://api.account.mrgrien.com/api/register', formData);

        if (!response.success) {
            this.#hideLoader("passwordBlock");
            this.#handleFormSubmissionError(response);
            return;
        }

        this.hideError("passwordBlock");
        formBlock.querySelector('#userLoginHidden').setAttribute('value', formData.email);

        if (this.#usesHostedCustomerLogin()) {
            this.#redirectToHostedCustomerLogin(formData.email);
            return;
        }

        this.#addBlockToHistory("passwordBlock");
        this.#sendForm(formBlock);
        this.#hideLoader("passwordBlock");
    }

    /**
     * Login password form
     *
     * Section where customer Login to his account
     */
    async finalSubmitForm() {
        this.#showLoader("finalPasswordBlock");
        const formData = this.#getFormData();
        const formBlock = document.getElementById('finalPasswordBlock');

        if (this.#usesHostedCustomerLogin()) {
            this.hideError("finalPasswordBlock");
            this.#redirectToHostedCustomerLogin(formData.email);
            return;
        }

        const loginResponseHtml = await this.#customerLogin(formData.email, formData.password);

        if(!loginResponseHtml) {
            this.#hideLoader("finalPasswordBlock");
            this.#showError("finalPasswordBlock", "Dieses Passwort ist falsch.");
            return;
        }

        this.hideError("finalPasswordBlock");
        formBlock.querySelector('#userLoginHidden').setAttribute('value', formData.email);
        
        // Extract customer data from login response HTML and redirect directly
        this.#redirectToExternalAccount(loginResponseHtml);
        this.#hideLoader("finalPasswordBlock");
    }

    async #customerLogin(email, password) {
        const data = new URLSearchParams();
        data.append('customer[email]', email);
        data.append('customer[password]', password);
        data.append('form_type', 'customer_login');
        data.append('utf8', '✓');

        return await this.#loginRequest("POST", "/account/login", data);
    }

    /********************* Blocks Visibility Handler *********************/
    #showVerificationBlock() {
        this.#showBlock("verificationBlock");
    }

    #showSecondLoginBlock() {
        const result = this.#getSecondLoginText();
        if (result) {
            this.#changeHeaderText("emailOrPhoneBlock", `Wie lautet Ihre ${result.head}?`, "head");
            this.#changeLabelText("emailOrPhoneBlock", result.label, "label");
            this.#showBlock("emailOrPhoneBlock");
        } else {
            console.error("The 'secondLogin' text is empty");
        }
    }

    #showNameBlock() {
        this.#showBlock("nameBlock");
    }

    #showPasswordBlock() {
        this.#showBlock("passwordBlock");
    }

    #showFinalPasswordBlock() {
        if (this.#usesHostedCustomerLogin()) {
            this.#prepareHostedLoginBlock();
        }

        this.#showBlock("finalPasswordBlock");
    }

    #nextStep() {
        if (!this.customerNew) {
            this.#showFinalPasswordBlock();
            return;
        }

        if(!this.email || !this.phone) {
            this.#showSecondLoginBlock();
        } else {
            this.#showNameBlock();
        }
    }

    /********************* Verification Code Sender (as default and resender) *********************/
    async sendVerification(login) {
        if (this.type !== 'phone') {
            this.#hideLoader("emailPhoneBlock");
            this.#nextStep();
            return;
        }

        const response = await this.#sendVerificationCode(login);

        if(!response.success) {
            console.error(response.message);
            return;
        }

        const resendButton = document.querySelector('.v_p_timer_text');
        this.#disableResendCodeButton(resendButton);

        this.#hideLoader("emailPhoneBlock");
        this.#startTimer(response.minutes, response.seconds);
        this.#showVerificationBlock();
    }

    /********************* Form Handler **********************/
    #sendForm(formBlock) {
        const loginForm = formBlock.querySelector('#customer_login');

        if (loginForm) {
            loginForm.submit();
        }
    }

    #getFormData() {
        const emailInput = document.getElementById(this.type === "email" ? 'emailPhoneInput' : 'emailOrPhoneInput');
        const phoneInput = document.getElementById(this.type === "email" ? 'emailOrPhoneInput' : 'emailPhoneInput');
        const nameInput = document.getElementById('nameInput');
        const passwordInput = document.getElementById(this.customerNew ? 'passwordInput' : 'finalPasswordInput');
        const passwordConfirmInput = document.getElementById('passwordConfirmInput');

        return {
            customerId: this.customerId,
            email: !this.customerNew ? (this.email || this.secondLogin || "") : emailInput.value,
            phone: !this.customerNew ? (this.phone || this.secondLogin || "") : phoneInput.value,
            name: nameInput.value,
            password: passwordInput.value,
            passwordConfirmation: passwordConfirmInput.value
        };
    }

    /********************* Text Definition For Blocks *********************/
    #getSecondLoginText() {
        let result = null;

        if (this.type === 'email' && !this.phone) {
            result = {
                head: "Telefonnummer",
                label: "Telefonnummer eingeben"
            };
        } else if (this.type === 'phone' && !this.email) {
            result = {
                head: "E-Mail-Adresse",
                label: "E-Mail eingeben"
            };
        }

        return result;
    }

    /********************* Logical Conditions Handler *********************/
    #isCustomerSecondary() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has("secondary");
    }

    #hasSpecialSymbols(inputString) {
        const regex = /[^a-zA-Z0-9_\s]/;
        return regex.test(inputString);
    }

    #isValidEmail(inputValue) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(inputValue);
    }

    #isValidPhone(inputValue) {
        const phonePattern = /^\+?[0-9]{9,12}$/;
        return phonePattern.test(inputValue);
    }

    /********************* Block Text Changing Handler *********************/
    #changeHeaderText(blockId, text) {
        this.#changeText(blockId, text, 'v_p_heading');
    }

    #changeLabelText(blockId, text) {
        this.#changeText(blockId, text, 'input-label');
    }

    #changeDescriptionText(blockId, text) {
        this.#changeText(blockId, text, 'v_p_text');
    }

    #changeText(blockId, text, elementType) {
        const blockElement = document.getElementById(blockId);
        if (blockElement) {
            const headerElement = blockElement.querySelector(`.${elementType}`);
            this.#updateText(headerElement, text);
        }
    }

    #updateText(block, text) {
        if (block) {
            block.textContent = text;
        } else {
            console.error(`Element not found.`);
        }
    }

    #addPlaceholder(inputId, value) {
        document.getElementById(inputId).placeholder = value;
    }

    #prepareHostedLoginBlock() {
        const finalPasswordBlock = document.getElementById("finalPasswordBlock");
        const legacyPasswordInput = finalPasswordBlock?.querySelector(".js-legacy-password-input");
        const recoverLink = finalPasswordBlock?.querySelector(".js-legacy-recover-pass");
        const button = document.getElementById("finalPasswordButton");

        if (legacyPasswordInput) {
            legacyPasswordInput.style.display = "none";
        }

        if (recoverLink) {
            recoverLink.style.display = "none";
        }

        this.#changeHeaderText("finalPasswordBlock", "Mit E-Mail-Code anmelden");
        this.#changeDescriptionText("finalPasswordBlock", "Wir leiten Sie zur sicheren Shopify-Anmeldung weiter. Dort erhalten Sie einen einmaligen Code per E-Mail.");

        if (button) {
            button.textContent = "Zur Anmeldung";
            this.#enableButton(button);
        }
    }

    /********************* Main Requests Handler *********************/
    async #getCustomer(login) {
        return await this.#apiRequest('POST', 'https://api.account.mrgrien.com/api/login', {
            login: login
        });
    }

    async #sendVerificationCode(login) {
        return await this.#apiRequest('POST', 'https://api.account.mrgrien.com/api/verification/send', {
            login,
            type: this.type
        });
    }

    async #checkVerificationCode(code) {
        return await this.#apiRequest('POST', 'https://api.account.mrgrien.com/api/verification/check', {
            login: this.loginValue,
            type: this.type,
            code: code
        });
    }

    /********************* Switching Blocks Handler *********************/
    #showBlock(blockId) {
        this.#hideBlocks();
        const block = document.getElementById(blockId);
        block.style.display = "flex";
    }

    #hideBlocks() {
        const allBlocks = document.querySelectorAll(".form-block");
        allBlocks.forEach(block => block.style.display = "none");
    }

    /********************* Block History Handler (Previous) *********************/
    previous() {
        const lastBlockId = this.#getLastBlock();
        if(!lastBlockId) return;

        this.#hideBlocks();
        this.#showPreviousBlock(lastBlockId);
        this.#removeBlockFromHistory(lastBlockId);
    }

    #showPreviousBlock(blockId) {
        document.getElementById(blockId).style.display = "flex";
    }

    #addBlockToHistory(item) {
        this.blockHistory.push(item);
    }

    #removeBlockFromHistory(item) {
        const index = this.blockHistory.indexOf(item);
        if (index !== -1) {
            this.blockHistory.splice(index, 1);
        }
    }

    #getLastBlock() {
        if (this.blockHistory.length > 0) {
            return this.blockHistory[this.blockHistory.length - 1];
        } else {
            return null;
        }
    }

    /********************* Password Visibility Handler *********************/
    togglePasswordVisibility(inputId, toggleIcon) {
        const input = document.getElementById(inputId);

        if (input.type === 'password') {
            input.type = 'text';
            toggleIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.197761 1.18644C0.0834442 1.29438 0.0139381 1.43749 0.00188114 1.58973C-0.0101758 1.74198 0.0360171 1.89325 0.132061 2.01605L0.197761 2.08745L3.8284 5.51725C2.05811 6.6891 0.794365 8.42433 0.268862 10.4048C0.228343 10.5678 0.257376 10.7394 0.349687 10.8824C0.441999 11.0254 0.590174 11.1283 0.76219 11.1689C0.934206 11.2096 1.11625 11.1847 1.26897 11.0996C1.4217 11.0145 1.53284 10.8761 1.57838 10.7142C2.04539 8.9564 3.1956 7.42888 4.80041 6.43526L6.42943 7.97378C5.77871 8.61596 5.42015 9.47327 5.43053 10.3621C5.44091 11.2509 5.81941 12.1005 6.48496 12.729C7.15051 13.3575 8.05018 13.7148 8.99128 13.7244C9.93237 13.7341 10.84 13.3953 11.5199 12.7806L16.847 17.8127C16.9675 17.9267 17.1292 17.9935 17.2996 17.9995C17.4701 18.0056 17.6366 17.9505 17.7658 17.8453C17.895 17.7401 17.9772 17.5926 17.9959 17.4325C18.0146 17.2724 17.9685 17.1115 17.8667 16.9822L17.801 16.9108L12.2993 11.7138L12.3002 11.7121L11.2202 10.6938L8.63715 8.25428H8.63895L6.04692 5.8088L6.04782 5.8071L5.02811 4.84659L1.15177 1.18644C1.02521 1.06706 0.853644 1 0.674766 1C0.495889 1 0.324325 1.06706 0.197761 1.18644ZM7.38344 8.87479L10.565 11.8804C10.1406 12.2675 9.57225 12.4817 8.9823 12.4769C8.39235 12.472 7.82802 12.2485 7.41084 11.8545C6.99367 11.4605 6.75704 10.9276 6.75191 10.3704C6.74679 9.81321 6.97358 9.27558 7.38344 8.87479ZM8.99985 3.97448C8.09984 3.97448 7.22683 4.10028 6.39973 4.33573L7.51304 5.38635C9.43865 5.02625 11.4372 5.37877 13.0953 6.37102C14.7535 7.36328 15.9446 8.91939 16.4222 10.7176C16.4689 10.8782 16.5802 11.0152 16.7324 11.0993C16.8845 11.1834 17.0655 11.2079 17.2366 11.1676C17.4077 11.1273 17.5553 11.0253 17.6478 10.8836C17.7403 10.7418 17.7705 10.5715 17.7317 10.4091C17.2437 8.57088 16.1194 6.93937 14.5374 5.77359C12.9554 4.60781 11.0064 3.97459 8.99985 3.97448ZM9.17535 6.95802L12.5963 10.1881C12.552 9.34476 12.1774 8.54712 11.5452 7.95017C10.9129 7.35322 10.0683 6.99959 9.17535 6.95802Z" fill="#3E3E3E"/> </svg>';
        } else {
            input.type = 'password';
            toggleIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.0008 7.0465C9.98264 7.0465 10.9243 7.4128 11.6185 8.06482C12.3128 8.71684 12.7028 9.60116 12.7028 10.5233C12.7028 11.4453 12.3128 12.3297 11.6185 12.9817C10.9243 13.6337 9.98264 14 9.0008 14C8.01897 14 7.07734 13.6337 6.38308 12.9817C5.68882 12.3297 5.29878 11.4453 5.29878 10.5233C5.29878 9.60116 5.68882 8.71684 6.38308 8.06482C7.07734 7.4128 8.01897 7.0465 9.0008 7.0465ZM9.0008 8.35028C8.38716 8.35028 7.79864 8.57922 7.36473 8.98673C6.93081 9.39424 6.68704 9.94694 6.68704 10.5233C6.68704 11.0996 6.93081 11.6523 7.36473 12.0598C7.79864 12.4673 8.38716 12.6962 9.0008 12.6962C9.61445 12.6962 10.203 12.4673 10.6369 12.0598C11.0708 11.6523 11.3146 11.0996 11.3146 10.5233C11.3146 9.94694 11.0708 9.39424 10.6369 8.98673C10.203 8.57922 9.61445 8.35028 9.0008 8.35028ZM9.0008 4C13.2702 4 16.9565 6.73794 17.9791 10.5745C18.0239 10.7422 17.996 10.9198 17.9014 11.0681C17.8068 11.2165 17.6533 11.3234 17.4747 11.3655C17.2962 11.4076 17.1071 11.3813 16.9492 11.2925C16.7912 11.2036 16.6773 11.0595 16.6325 10.8918C16.204 9.2955 15.2204 7.87923 13.8375 6.86756C12.4547 5.85589 10.7518 5.30672 8.9989 5.30712C7.246 5.30752 5.54341 5.85747 4.16109 6.86977C2.77877 7.88207 1.79584 9.29878 1.36816 10.8953C1.3461 10.9784 1.30683 11.0566 1.25259 11.1254C1.19835 11.1942 1.1302 11.2524 1.05204 11.2965C0.973875 11.3406 0.887226 11.3698 0.797039 11.3825C0.706852 11.3951 0.614893 11.391 0.526413 11.3703C0.437932 11.3496 0.354663 11.3127 0.28136 11.2617C0.208056 11.2108 0.146154 11.1468 0.099187 11.0734C0.0522201 11 0.0211086 10.9186 0.00762879 10.8339C-0.00585104 10.7492 -0.00143536 10.6628 0.020624 10.5797C0.52254 8.69995 1.67881 7.03152 3.3058 5.83943C4.93279 4.64734 6.93724 3.99992 9.0008 4Z" fill="#3E3E3E"/> </svg>';
        }
    }

    /********************* Error/Loader Handler *********************/
    #handleFormSubmissionError(response) {
        if (response.errors) {
            const error = this.#getFirstError(response.errors);
            if (error) this.#showCommonErrorPopup(error);
        } else {
            this.#showError("passwordBlock", response.message);
        }
    }

    #showCommonErrorPopup(errorMessage) {
        const errorPopup = document.getElementById('errorPopup');

        errorPopup.querySelector('p').textContent = errorMessage;
        errorPopup.style.display = 'block';

        errorPopup.style.animation = '';
        errorPopup.offsetHeight;

        setTimeout(() => {
            errorPopup.style.animation = 'fade-out 0.5s ease-in forwards';
        }, 3000);
    }

    #showError(blockId, message) {
        const errorBlock = this.#getErrorElements(blockId);
        const messageBlock = errorBlock.messageBlock.querySelector('.error-text');

        if(this.#isTooLong(message)) {
            messageBlock.classList.add('long-error');
        }

        errorBlock.element.querySelector('input').style.color = "#ff0000";
        errorBlock.messageBlock.querySelector('.error-text').textContent = message;
        errorBlock.messageBlock.style.visibility = "visible";
    }

    hideError(blockId) {
        const errorBlock = this.#getErrorElements(blockId);
        const messageBlock = errorBlock.messageBlock.querySelector('.error-text');

        if(messageBlock.classList.contains('long-error')) {
            messageBlock.classList.remove('long-error');
        }

        errorBlock.element.querySelector('input').style.color = "#000000";
        errorBlock.messageBlock.style.visibility = "hidden";
        errorBlock.messageBlock.querySelector(".error-text").innerText = "";
    }

    #getFirstError(errors) {
        for (const key in errors) {
            if (errors.hasOwnProperty(key) && errors[key].length > 0) {
                return errors[key][0];
            }
        }
    }

    #getErrorElements(blockId) {
        return {
            element: document.getElementById(blockId),
            messageBlock: document.getElementById(blockId).querySelector(".error-message")
        }
    }

    #isTooLong(message) {
        return message.length >= 30;
    }

    #showLoader(blockId) {
        document.getElementById(blockId).querySelector('.dot-loader').style.display = 'block';
    }

    #hideLoader(blockId) {
        document.getElementById(blockId).querySelector('.dot-loader').style.display = 'none';
    }

    /********************* Timer Handler *********************/
    #startTimer(minutes, seconds) {
        let time = minutes * 60 + seconds;
        const timerElement = document.querySelector('.v_p_timer p');
        const resendButton = document.querySelector('.v_p_timer_text');

        if (!timerElement || !resendButton) {
            console.error('Timer or resend element not found');
            return;
        }

        const intervalId = setInterval(() => {
            time--;

            const mins = Math.floor(time / 60);
            const secs = time % 60;

            timerElement.textContent = `${mins}:${secs < 10 ? '0' : ''}${secs}`;

            if (time <= 0) {
                clearInterval(intervalId);
                this.#enableResendCodeButton(resendButton); // Pass the resendButton to the method
            }
        }, 1000);
    }

    /********************* Setup Event Listener *********************/
    #setupPasswordEventListeners(passwordId, confirmPasswordId, buttonId) {
        const passwordInput = document.getElementById(passwordId);
        const confirmPasswordInput = document.getElementById(confirmPasswordId);
        const button = document.getElementById(buttonId);

        this.#handlePasswordInput(passwordInput, confirmPasswordInput, button);
        passwordInput.addEventListener('input', () => this.#handlePasswordInput(passwordInput, confirmPasswordInput, button));
        confirmPasswordInput.addEventListener('input', () => this.#handlePasswordInput(passwordInput, confirmPasswordInput, button));
    }

    #handlePasswordInput(passwordId, confirmPasswordId, button) {
        const passwordValue = passwordId.value;
        const confirmPasswordValue = confirmPasswordId.value;

        if (passwordValue && confirmPasswordValue) {
            this.#enableButton(button);
        } else {
            this.#disableButton(button);
        }
    }

    #setupEventListeners(inputId, buttonId) {
        const loginInput = document.getElementById(inputId);
        const button = document.getElementById(buttonId);

        this.#handleInput(loginInput, button);
        loginInput.addEventListener('input', () => this.#handleInput(loginInput, button));
    }

    #handleInput(loginInput, button) {
        if (loginInput.value.trim() !== '') {
            this.#enableButton(button);
        } else {
            this.#disableButton(button);
        }
    }

    /********************* Buttons State Handler *********************/
    #enableButton(button) {
        button.removeAttribute('disabled');
        button.classList.remove('disabled');
    }

    #disableButton(button) {
        button.setAttribute('disabled', true);
        button.classList.add('disabled');
    }

    #enableResendCodeButton(resendButton) {
        resendButton.classList.add('active');
        resendButton.removeAttribute('disabled');
    }

    #disableResendCodeButton(resendButton) {
        resendButton.classList.remove('active');
        resendButton.setAttribute('disabled', true);
    }

    /********************* Prevent "Enter" Button Pressing *********************/
    preventEnterPressing(blockIdList) {
        const _this = this;

        blockIdList.forEach(function (blockId) {
            document.getElementById(blockId).addEventListener('keydown', async function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    await _this.finalSubmitForm();
                }
            });
        });
    }

    /********************* API Requests *********************/
    async #apiRequest(method, apiUrl, data) {
        const response = await fetch(apiUrl, {
            method,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(data)
        });

        return response.json();
    }

    async #loginRequest(method, apiUrl, data) {
        try {
            const response = await fetch(apiUrl, {
                method: method,
                body: data,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });

            if (response.ok) {
                const responseData = await response.text();
                const isSuccess = responseData.indexOf("shopify-section-account-details-custom") >= 0;
                // Return HTML response if login successful, false otherwise
                return isSuccess ? responseData : false;
            }
        } catch (error) {
            return false;
        }
        return false;
    }

    #usesHostedCustomerLogin() {
        return Boolean(this.storefrontLoginUrl);
    }

    #redirectToHostedCustomerLogin(email) {
        const loginUrl = this.#getHostedCustomerLoginUrl(email);

        if (!loginUrl) {
            this.#hideLoader("finalPasswordBlock");
            this.#showError("finalPasswordBlock", "Die Shopify-Anmeldung konnte nicht gestartet werden.");
            return;
        }

        window.location.href = loginUrl;
    }

    #getHostedCustomerLoginUrl(email) {
        if (!this.storefrontLoginUrl) {
            return null;
        }

        const loginUrl = new URL(this.storefrontLoginUrl, window.location.origin);

        if (email) {
            loginUrl.searchParams.set("login_hint", email);
        }

        return loginUrl.toString();
    }

    #redirectLoggedInCustomer() {
        const customerIdElement = document.getElementById("customerId");
        const secretKeyElement = document.getElementById("secretKey");

        if (!customerIdElement || !secretKeyElement) {
            return false;
        }

        const shopifyId = customerIdElement.value;
        const secretKey = secretKeyElement.value.replace(/secret:/g, "");

        if (!shopifyId || !secretKey) {
            return false;
        }

        const redirectUrl = `https://account.mrgrien.com/?shopifyId=${encodeURIComponent(shopifyId)}&secretKey=${encodeURIComponent(secretKey)}`;
        window.location.href = redirectUrl;
        return true;
    }

    #redirectToExternalAccount(htmlResponse) {
        try {
            // Parse HTML response from login to extract customerId and secretKey from hidden inputs
            const customerIdMatch = htmlResponse.match(/id="customerId"\s+value="([^"]+)"/);
            const secretKeyMatch = htmlResponse.match(/id="secretKey"\s+value="([^"]+)"/);
            
            if (customerIdMatch && secretKeyMatch) {
                const shopifyId = customerIdMatch[1];
                let secretKey = secretKeyMatch[1];
                
                // Remove "secret:" prefix if present
                secretKey = secretKey.replace(/secret:/g, "");
                
                // Redirect to external account URL
                const redirectUrl = `https://account.mrgrien.com/?shopifyId=${encodeURIComponent(shopifyId)}&secretKey=${encodeURIComponent(secretKey)}`;
                window.location.href = redirectUrl;
                return;
            }
            
            // Fallback: if we can't get the data, redirect to account page
            window.location.href = '/account';
        } catch (error) {
            console.error('Error parsing customer data:', error);
            // Fallback: redirect to account page
            window.location.href = '/account';
        }
    }
    /********************************************************/
}

const loginHandler = new LoginHandler();
loginHandler.preventEnterPressing(["passwordBlock", "finalPasswordBlock"]);